export default __webpack_public_path__ + "static/media/img5.17a7f949.jpg";